import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MenuService } from './services/menu.service';
import { ScreenSizeService } from '../../services/screen-size.service';

@Component({
	selector: 'app-menu',
	templateUrl: './menu.component.html',
	styleUrls: ['./menu.component.scss'],
	encapsulation: ViewEncapsulation.None,
	providers: [MenuService],
	standalone: false
})
export class MenuComponent implements OnInit {
	@Input() menuItems: any[];
	@Input() menuParentId: any;
	parentMenu: Array<any>;
	isMobile = false;

	constructor(
		public menuService: MenuService,
		private readonly screenSizeService: ScreenSizeService,
		private readonly matIconRegistry: MatIconRegistry,
		private readonly domSanitizer: DomSanitizer
	) {
		this.matIconRegistry.addSvgIcon(
			'application-error-icon',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'assets/images/banner/application-error-icon.svg'
			)
		);
	}

	ngOnInit() {
		this.parentMenu = this.menuItems.filter(
			(item) => item.parentId == this.menuParentId
		);
		this.screenSizeService.isSmall$.subscribe(
			(response) => (this.isMobile = response)
		);
	}

	onClick(menuId: any) {
		this.menuService.toggleMenuItem(menuId);
		this.menuService.closeOtherSubMenus(this.menuItems, menuId);
	}
}
